//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Container, Checkbox, Grid, Collapse, CircularProgress } from '@material-ui/core';
// import CheckIcon from '@material-ui/icons/Check';
import ArrowRightAltIcon from '@material-ui/icons/ArrowForward';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { createStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useHistory } from 'react-router-dom';

//logo and images
import optionSrc from '../../images/advertise/option.png';
import optionSrc2 from '../../images/advertise/option2.png';
import optionSrc3 from '../../images/advertise/option3.png';
import adPlacementPicture from '../../images/advertise/adPlacementBg.png';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { BASE_URL, PRICE_ADVERTISEMENT_PLACEMENT } from '../../common/constants';
import { PATH_ADVERTISE } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { checkAvailability, makePlacementsOnHold } from '../../common/services/adServices';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';

import AfitdAutocompleteLite from '../../common/elemental/AfitdAutocompleteLite';
import AfitdDatePicker from '../../common/elemental/AfitdDatePicker';
import AfitdTimePicker from '../../common/elemental/AfitdTimePicker';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdMessageDialog from '../../common/elemental/AfitdMessageDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
import getMinutes from 'date-fns/getMinutes';
import getHours from 'date-fns/getHours';
import addMinutes from 'date-fns/addMinutes';
import set from 'date-fns/set';

import _get from 'lodash/get';
import _map from 'lodash/map';
import _join from 'lodash/join';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { padding: 20, [theme.breakpoints.down('sm')]: { padding: '20px 0px' } },
    exampleWithNoPropsOnlyStyles: { color: 'red', marginTop: 30, marginBottom: 40 },
    nonReactElementExample: { color: 'blue', marginTop: 50, cursor: 'pointer' },
    container1: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    container2: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    container3: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        border: '2px solid #D5D7DD',
        marginTop: '20px',
    },
    heading: {
        fontSize: '26px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '40px',
        marginTop: '40px',
    },
    title: {
        fontSize: '20px',
        position: 'relative',
        top: '3px',
        [theme.breakpoints.down('md')]: {
            fontSize: '17px',
        },
    },
    qualities: {
        // position: 'relative',
        // top: '-1px',
        // left: '16px',
        paddingLeft: '10px',
    },
    features: {
        fontSize: '14px',
        marginBottom: '20px',
    },
    featureBody: {
        marginTop: '6px',
        display: 'flex',
    },
    contentBody: {
        marginLeft: '10px',
        marginTop: '20px',
    },
    smallSub: {
        position: 'relative',
        top: '10px',
        left: '37px',
    },
    nextButtonContainer: {
        textAlign: 'right',
        marginTop: '32px',
    },
    nextButton: {
        textAlign: 'right',
        marginTop: '32px',
    },
    backButtonContainer: {
        textAlign: 'left',
        marginTop: '32px',
    },
    backButton: {
        textAlign: 'left',
        marginTop: '32px',
    },
    progressGrid: {
        textAlign: 'center',
    },
    orange: {
        color: '#FC821F',
    },
    progressGridContainerSm: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 34,
    },
    listBody: {
        marginLeft: '-28px',
    },
    datePicker: {
        border: `2px solid lightgrey`,
        width: '100%',
        cursor: 'pointer',
        borderRadius: '5px',
        '& > .MuiInputBase-root': {
            cursor: 'pointer !important',
            border: 'none',
            padding: '10px',
            backgroundColor: '#fafafc',
        },
    },
    newRowContainer: { display: 'flex', justifyContent: 'space-between', marginTop: 40, [theme.breakpoints.down('sm')]: { marginTop: 20 } },
    checkAvailabilityRow: {
        marginTop: '20px',
        border: `2px solid lightgrey`,
        padding: '20px',
        borderRadius: '8px',
    },
    timeSlotText: {
        fontSize: '12px',
        color: theme.palette.secondary.main,
        textAlign: 'center',
    },
    adPlacementPicture: {
        position: 'relative',
    },
    optionImage: {
        width: '100%',
        marginTop: '15px',
        position: 'absolute',
    },
    placementAdSection: {
        position: 'absolute',
        width: '282px',
        height: '282px',
        top: '76px',
        right: '13px',
        backgroundImage: `URL(${adPlacementPicture})`,
        backgroundSize: 'cover',
        [theme.breakpoints.down('md')]: {
            top: '61px',
            width: '207px',
            height: '207px',
        },
        // background: 'rgba(29, 138, 139, 0.06)',
        // border: `1px dashed ${theme.palette.secondary.main}`,
    },
    placementBlock: {
        padding: '30px',
        paddingLeft: '10px',
        paddingRight: '10px',
        textAlign: 'center',
        height: '140px',
        [theme.breakpoints.down('md')]: {
            height: '103px',
            padding: '10px',
        },
        // border: `1px dashed ${theme.palette.secondary.main}`,
    },
    placementNumber: {
        lineHeight: '30px',
        fontSize: '25px',
        borderRadius: '50%',
        padding: '16px',
        width: '60px',
        height: '60px',
        margin: 'auto',
        background: '#9B9E9C',
        color: 'white',
        paddingLeft: '18px',
        boxShadow: '0px 4px 4px 0px #00000040',
        [theme.breakpoints.down('md')]: {
            fontSize: '20px',
            padding: '10px',
            width: '45px',
            height: '45px',
        },
    },
    placementAvailabilityText: {
        fontSize: '17px',
        marginTop: '10px',
        color: '#9B9E9C',
        fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    placementAvailableList: {
        marginTop: '-50px',
    },
    checkIcon: {
        color: theme.palette.secondary.main,
        fontSize: '19px',
        marginTop: '2px',
        marginRight: '5px',
    },
    listText: {
        fontSize: '14px',
        display: 'flex',
        fontWeight: 'bold',
    },
    availableText: {
        color: theme.palette.secondary.main,
        fontSize: '14px',
        display: 'flex',
        fontWeight: 'bold',
    },
    closeIcon: {
        color: theme.palette.error.main,
        fontSize: '19px',
        marginTop: '2px',
        marginRight: '5px',
    },
    notAvailableText: {
        color: theme.palette.error.main,
        fontSize: '14px',
        display: 'flex',
        fontWeight: 'bold',
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, checkState, setCheckState, history, isDisabledButton, handleNext, unavailablePlacementDialogOpen, setUnavailablePlacementDialogOpen, loading } = params;
    const { datePicker: datePickerCls } = classes;

    const placementArray = ['1', '2', '3', '4'];

    const defns = {
        helloText: { variant: 'h4' },
        textFieldExample: { value: 'Hello TextField' },
        nonReactElementExample: {
            onClick: evt => {
                alert('Clicked!');
            },
        },
        gridBody: {
            container: true,
            spacing: 1,
        },
        gridBody1: {
            container: true,
            spacing: 1,
            alignItems: 'center',
        },
        itemGrid: { item: true, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 },
        optionImage: {
            src: optionSrc,
        },
        optionImage2: {
            src: optionSrc2,
            style: {
                width: '100%',
                marginTop: '15px',
            },
        },
        optionImage3: {
            src: optionSrc3,
            style: {
                width: '100%',
                marginTop: '15px',
            },
        },
        jobCenterCheck: {
            checked: checkState?.jobCtr,
            onChange: e => {
                setCheckState({ ...checkState, jobCtr: !checkState?.jobCtr });
            },
        },
        talentCenterCheck: {
            checked: checkState?.talentCtr,
            onChange: e => {
                setCheckState({ ...checkState, talentCtr: !checkState?.talentCtr });
            },
        },
        employerCenterCheck: {
            checked: checkState?.empSearch,
            onChange: e => {
                setCheckState({ ...checkState, empSearch: !checkState?.empSearch });
            },
        },
        container1: {
            style: {
                border: checkState?.jobCtr && '2px solid #1D8A8B',
                background: checkState?.jobCtr && '#F1F8F8',
            },
        },
        container2: {
            style: {
                border: checkState?.talentCtr && '2px solid #1D8A8B',
                background: checkState?.talentCtr && '#F1F8F8',
            },
        },
        container3: {
            style: {
                border: checkState?.empSearch && '2px solid #1D8A8B',
                background: checkState?.empSearch && '#F1F8F8',
            },
        },

        footerGridItem: {
            xl: 5,
            lg: 5,
            md: 5,
            sm: 6,
            xs: 6,
        },
        progress: {
            variant: 'determinate',
            value: 60,
        },
        nextButton: {
            color: 'primary',
            onClick: () => {
                !isDisabledButton && handleNext();
            },
            disabled: isDisabledButton || loading,
        },
        backButton: {
            onClick: () => history.push(`${BASE_URL}${PATH_ADVERTISE}/step2`),
        },
        progressGrid: { item: true, xs: 2 },
        availabilityGrid: {
            container: true,
            spacing: 2,
            // alignItems: 'center',
        },
        availabilityItemGrid: { item: true, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 },
        itemGrid2: { item: true, xl: 4, lg: 4, md: 4, sm: 6, xs: 6 },
        placementInput: {
            name: 'placement',
            placeholder: 'Select Placement',
            options: placementArray,
            // onChange: () => {},
        },
        inputDate: {
            // type: 'date',
            name: 'date',
            className: cx(datePickerCls),
            minDate: new Date(), // to disable past dates
        },
        inputTime: {
            // type: 'time',
            name: 'time',
            className: cx(datePickerCls),
            minutesStep: 30,
        },
        placementGridContainer: {
            container: true,
            alignItems: 'center',
            justifyContent: 'center',
        },
        placementGridRow: {
            item: true,
            xs: 12,
        },
        placementGrid: {
            container: true,
            alignItems: 'center',
            justifyContent: 'center',
        },
        placementBlock: {
            item: true,
            xs: 6,
        },
        unavailablePlacementDialog: {
            title: 'You have selected an unavailable placement for your Ad!',
            children: (
                <AfitdTypography>
                    One or more placements you selected for your Ad is currently unavailable. Please select a different placement or select another Date/Time.
                </AfitdTypography>
            ),
            open: unavailablePlacementDialogOpen,
            onClose: async () => {
                setUnavailablePlacementDialogOpen(false);
            },
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const BorderLinearProgress = withStyles(theme =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor: '#F0F2F6',
        },
        bar: {
            borderRadius: 5,
            backgroundColor: '#1D8A8B',
        },
    }),
)(LinearProgress);

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Step3Page = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const history = useHistory();
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const {
        scrollToPageTop,
        setAdvertisementData,
        advertisementData,
        customerData,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        checkState,
        setCheckState,
        checkedAvailability,
        setCheckedAvailability,
        hideJobCenterList,
        setHideJobCenterList,
        hideTalentCenterList,
        setHideTalentCenterList,
        hideEmpSearchList,
        setHideEmpSearchList,
        jobCenterAdDetails,
        setJobCenterAdDetails,
        talentCenterAdDetails,
        setTalentCenterAdDetails,
        employerSearchAdDetails,
        setEmployerSearchAdDetails,
        jobCenterPlacementData,
        setJobCenterPlacementData,
        talentCenterPlacementData,
        setTalentCenterPlacementData,
        empSearchPlacementData,
        setEmpSearchPlacementData,
        adImageUrl,
        setOnHoldDocIds,
        setShowTimer,
        setPaymentIntentDescription,
    } = layoutContext;

    const adCusId = _get(customerData, 'adCusId', null);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);
    const [loading, setLoading] = React.useState(false);

    // const [nextBtnDisabled, setNextBtnDisabled] = React.useState(true);
    const [isDisabledButton, setIsDisabledButton] = React.useState(false);

    const [unavailablePlacementDialogOpen, setUnavailablePlacementDialogOpen] = React.useState(false);

    const [jobCtrLoading, setJobCtrLoading] = React.useState(false);
    const [talentCtrLoading, setTalentCtrLoading] = React.useState(false);
    const [empSearchLoading, setEmpSearchLoading] = React.useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    useEffect(() => {
        if (!adCusId) history.push(`${BASE_URL}${PATH_ADVERTISE}/start`);
        // don't need to run multiple Times
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            checkPageStatus(checkState?.jobCtr, checkedAvailability?.jobCtr) &&
            checkPageStatus(checkState?.talentCtr, checkedAvailability?.talentCtr) &&
            checkPageStatus(checkState?.empSearch, checkedAvailability?.empSearch)
            //  &&
            // userCheckAvailbility()
        )
            setIsDisabledButton(false);
        else setIsDisabledButton(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkState, checkedAvailability]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleChangePlacement = (value, type) => {
        if (type === 'TC') {
            setTalentCenterAdDetails({ ...talentCenterAdDetails, placement: value });
        }
        if (type === 'JC') {
            setJobCenterAdDetails({ ...jobCenterAdDetails, placement: value });
        }
        if (type === 'ES') {
            setEmployerSearchAdDetails({ ...employerSearchAdDetails, placement: value });
        }
    };

    const handleChangeDate = (value, type) => {
        if (type === 'TC') {
            const hours = getHours(new Date(talentCenterAdDetails?.time));
            const minutes = getMinutes(new Date(talentCenterAdDetails?.time));
            const date = set(new Date(value), { hours, minutes, seconds: 0, milliseconds: 0 });

            setTalentCenterAdDetails({ ...talentCenterAdDetails, date, startDt: date });
            setCheckedAvailability({ ...checkedAvailability, talentCtr: false });
            setTalentCenterPlacementData({});
            setHideTalentCenterList(true);
        }
        if (type === 'JC') {
            const hours = getHours(new Date(jobCenterAdDetails?.time));
            const minutes = getMinutes(new Date(jobCenterAdDetails?.time));
            const date = set(new Date(value), { hours, minutes, seconds: 0, milliseconds: 0 });

            setJobCenterAdDetails({ ...jobCenterAdDetails, date, startDt: date });
            setCheckedAvailability({ ...checkedAvailability, jobCtr: false });
            setJobCenterPlacementData({});
            setHideJobCenterList(true);
        }
        if (type === 'ES') {
            const hours = getHours(new Date(employerSearchAdDetails?.time));
            const minutes = getMinutes(new Date(employerSearchAdDetails?.time));
            const date = set(new Date(value), { hours, minutes, seconds: 0, milliseconds: 0 });

            setEmployerSearchAdDetails({ ...employerSearchAdDetails, date, startDt: date });
            setCheckedAvailability({ ...checkedAvailability, empSearch: false });
            setEmpSearchPlacementData({});
            setHideEmpSearchList(true);
        }
    };

    const handleChangeTime = (value, type) => {
        const hours = getHours(new Date(value));
        const minutes = getMinutes(new Date(value));

        if (type === 'TC') {
            const newDate = set(new Date(talentCenterAdDetails?.date), { hours, minutes, seconds: 0, milliseconds: 0 });

            setTalentCenterAdDetails({ ...talentCenterAdDetails, time: newDate, date: newDate, startDt: newDate });
            setCheckedAvailability({ ...checkedAvailability, talentCtr: false });
            setTalentCenterPlacementData({});
            setHideTalentCenterList(true);
        }
        if (type === 'JC') {
            const newDate = set(new Date(jobCenterAdDetails?.date), { hours, minutes, seconds: 0, milliseconds: 0 });

            setJobCenterAdDetails({ ...jobCenterAdDetails, time: newDate, date: newDate, startDt: newDate });
            setCheckedAvailability({ ...checkedAvailability, jobCtr: false });
            setJobCenterPlacementData({});
            setHideJobCenterList(true);
        }
        if (type === 'ES') {
            const newDate = set(new Date(employerSearchAdDetails?.date), { hours, minutes, seconds: 0, milliseconds: 0 });

            setEmployerSearchAdDetails({ ...employerSearchAdDetails, time: newDate, date: newDate, startDt: newDate });
            setCheckedAvailability({ ...checkedAvailability, empSearch: false });
            setEmpSearchPlacementData({});
            setHideEmpSearchList(true);
        }
    };

    const handleClickAvailability = async ({ placement, startDt, type }) => {
        let dto = {
            pos: placement,
            startDt,
            setSnackbarMessage,
            setSnackbarErrorMessage,
        };

        if (type === 'JC') {
            setJobCtrLoading(true);
            dto = { ...dto, jobCtr: true, setLoading: setJobCtrLoading };
        }
        if (type === 'TC') {
            setTalentCtrLoading(true);
            dto = { ...dto, talentCtr: true, setLoading: setTalentCtrLoading };
        }
        if (type === 'ES') {
            setEmpSearchLoading(true);
            dto = { ...dto, empSearch: true, setLoading: setEmpSearchLoading };
        }
        // call the service
        const notAvailablePlacementData = await checkAvailability(dto);

        // display Data
        if (type === 'JC') {
            setJobCenterPlacementData({ allSlotsAvailable: notAvailablePlacementData?.length === 0, queryData: notAvailablePlacementData });
            setHideJobCenterList(false);
            setCheckedAvailability({ ...checkedAvailability, jobCtr: true });
        }
        if (type === 'TC') {
            setTalentCenterPlacementData({ allSlotsAvailable: notAvailablePlacementData?.length === 0, queryData: notAvailablePlacementData });
            setHideTalentCenterList(false);
            setCheckedAvailability({ ...checkedAvailability, talentCtr: true });
        }
        if (type === 'ES') {
            setEmpSearchPlacementData({ allSlotsAvailable: notAvailablePlacementData?.length === 0, queryData: notAvailablePlacementData });
            setHideEmpSearchList(false);
            setCheckedAvailability({ ...checkedAvailability, empSearch: true });
        }
    };

    const validNextButton = () => {
        let jobCtrValid = true;
        let talentCtrValid = true;
        let empSearchValid = true;

        if (checkState?.jobCtr) {
            const selectedPlacement = parseInt(jobCenterAdDetails?.placement);
            const selectedPlacementNotAvailable = jobCenterPlacementData?.queryData?.find(d => d.pos === selectedPlacement);
            if (selectedPlacementNotAvailable) jobCtrValid = false;
            // else jobCtrValid = true;
        }
        if (checkState?.talentCtr) {
            const selectedPlacement = parseInt(talentCenterAdDetails?.placement);
            const selectedPlacementNotAvailable = talentCenterPlacementData?.queryData?.find(d => d.pos === selectedPlacement);
            if (selectedPlacementNotAvailable) talentCtrValid = false;
            // else talentCtrValid = true;
        }
        if (checkState?.empSearch) {
            const selectedPlacement = parseInt(employerSearchAdDetails?.placement);
            const selectedPlacementNotAvailable = empSearchPlacementData?.queryData?.find(d => d.pos === selectedPlacement);
            if (selectedPlacementNotAvailable) empSearchValid = false;
            // else empSearchValid = true;
        }
        return jobCtrValid && talentCtrValid && empSearchValid;
    };

    const checkPageStatus = (selected, available) => {
        if (selected) {
            return selected && available;
        } else {
            return true;
        }
    };

    // const userCheckAvailbility = () => {
    // console.log(empSearchPlacementData?.queryData, jobCenterPlacementData?.queryData, talentCenterPlacementData?.queryData);
    // if (!empSearchPlacementData?.queryData && !jobCenterPlacementData?.queryData && !talentCenterPlacementData?.queryData) return false;
    // else
    //     return !empSearchPlacementData?.queryData || !jobCenterPlacementData?.queryData || !talentCenterPlacementData?.queryData;
    // };

    const handleNext = async () => {
        if (validNextButton()) {
            // history.push(`${BASE_URL}${PATH_ADVERTISE}/step4`);

            setLoading(true);

            const advertisements = [];
            const dto = {
                adCusId,
                imgUrl: adImageUrl,
            };

            if (checkState?.jobCtr) {
                const pos = parseInt(jobCenterAdDetails?.placement);
                const startDt = jobCenterAdDetails?.startDt;
                const endDt = addMinutes(startDt, 30);

                advertisements.push({
                    ...dto,
                    pos,
                    jobCtr: true,
                    startDt,
                    endDt,
                });
            }
            if (checkState?.talentCtr) {
                const pos = parseInt(talentCenterAdDetails?.placement);
                const startDt = talentCenterAdDetails?.startDt;
                const endDt = addMinutes(startDt, 30);

                advertisements.push({
                    ...dto,
                    pos,
                    talentCtr: true,
                    startDt,
                    endDt,
                });
            }
            if (checkState?.empSearch) {
                const pos = parseInt(employerSearchAdDetails?.placement);
                const startDt = employerSearchAdDetails?.startDt;
                const endDt = addMinutes(startDt, 30);

                advertisements.push({
                    ...dto,
                    pos,
                    empSearch: true,
                    startDt,
                    endDt,
                });
            }

            // set the description for payment intent (page 5)
            const description = _join(
                _map(advertisements, ad => {
                    const page = ad.jobCtr ? 'Job Center' : ad.talentCtr ? 'Talent Center' : ad.empSearch ? 'Employer Search' : 'Unknown Page';
                    return `${page} Ad Placement #${ad.pos}`;
                }),
                ' / ',
            );

            await makePlacementsOnHold({
                advertisements,
                setSnackbarMessage,
                setSnackbarErrorMessage,
                setLoading,
                callBack: docIdList => {
                    setOnHoldDocIds(docIdList);
                    setLoading(false);
                    document.getElementsByClassName('App')[0].firstElementChild.scrollTo(0, 0);
                    history.push(`${BASE_URL}${PATH_ADVERTISE}/step4`);
                    const minutesToAdd = 5;
                    const currentDate = new Date();
                    const onHoldEndDt = addMinutes(currentDate, minutesToAdd);
                    localStorage.setItem('onHoldEndDt', onHoldEndDt);
                    setShowTimer(true);
                    setPaymentIntentDescription(description);
                },
                callBackIfPlacementsNotAvailable: arr => {
                    setLoading(false);
                    setCheckedAvailability({
                        jobCtr: false,
                        talentCtr: false,
                        empSearch: false,
                    });
                    setUnavailablePlacementDialogOpen(true);
                    if (arr) {
                        // eslint-disable-next-line no-unused-expressions
                        arr?.forEach(el => {
                            if (el?.jobCtr) {
                                setJobCenterAdDetails({ placement: '', date: null, time: new Date().setHours(24, 0, 0, 0) });
                                setJobCenterPlacementData({});
                            }
                            if (el?.talentCtr) {
                                setTalentCenterAdDetails({ placement: '', date: null, time: new Date().setHours(24, 0, 0, 0) });
                                setTalentCenterPlacementData({});
                            }
                            if (el?.empSearch) {
                                setEmployerSearchAdDetails({ placement: '', date: null, time: new Date().setHours(24, 0, 0, 0) });
                                setEmpSearchPlacementData({});
                            }
                        });
                    }
                },
            });
        } else {
            setUnavailablePlacementDialogOpen(true);
        }
    };

    //---------------------------------------------------------------------
    // Helper Component
    //---------------------------------------------------------------------
    const getPlacementText = ({ queryData, available, allSlotsAvailable }) => {
        if (allSlotsAvailable) return 'Available';
        else return queryData?.length > 0 ? (available ? 'Available' : 'Not Available') : 'Ad Space';
    };

    const getPlacementTextStyle = ({ queryData, available, allSlotsAvailable }) => {
        if (allSlotsAvailable) {
            return { color: theme.palette.secondary.main };
        } else {
            // if (queryData === undefined && available) return { color: theme.palette.secondary.main };
            if (queryData?.length > 0 && available) return { color: theme.palette.secondary.main };
            else return {};
        }
    };

    const getPlacementNumberStyle = ({ queryData, available, allSlotsAvailable }) => {
        if (allSlotsAvailable) {
            return { backgroundColor: theme.palette.secondary.main };
        } else {
            if (queryData?.length > 0 && available) return { backgroundColor: theme.palette.secondary.main };
            else return {};
        }
    };

    const CheckAvailabilityComponent = props => {
        const { placement, date, time, type, data, hideList, loading } = props;
        const queryData = _get(data, 'queryData', []);
        const allSlotsAvailable = _get(data, 'allSlotsAvailable', false);

        const checkAvailabilityBtnDisabled = placement && date && time;

        const selectedPlacementNumber = parseInt(placement);

        const arr = [...Array(4)].map((_, i) => i + 1);
        const selectedPlacementNotAvailable = queryData?.find(d => d.pos === selectedPlacementNumber);
        const newA = arr?.filter(d => d.pos !== selectedPlacementNumber);

        return (
            <div {...defns.checkAvailabilityRow}>
                <Grid {...defns.availabilityGrid}>
                    <>
                        <Grid {...defns.availabilityItemGrid}>
                            <p {...defns.fieldLabel}>Select Placement</p>
                            <AfitdAutocompleteLite value={placement} onChange={(name, value) => handleChangePlacement(value, type)} should {...defns.placementInput} />
                        </Grid>
                        <Grid {...defns.itemGrid2}>
                            <p {...defns.fieldLabel}>Select a Date</p>
                            <AfitdDatePicker value={date} onChange={e => handleChangeDate(e, type)} {...defns.inputDate} />
                        </Grid>
                        <Grid {...defns.itemGrid2}>
                            <p {...defns.fieldLabel}>Select a Time</p>
                            <AfitdTimePicker value={time} onChange={e => handleChangeTime(e, type)} {...defns.inputTime} />
                            <AfitdTypography variant="body2" {...defns.timeSlotText}>
                                *Time slots can be selected at ‘:00' and ':30’ only.
                            </AfitdTypography>
                        </Grid>
                    </>
                </Grid>

                <div {...defns.newRowContainer}>
                    {!hideList && placement && (
                        <div {...defns.placementAvailableList}>
                            {selectedPlacementNumber === selectedPlacementNotAvailable?.pos && queryData?.length > 0 && (
                                <AfitdTypography
                                    {...defns.listText}
                                    style={selectedPlacementNotAvailable ? { color: theme.palette.error.main } : { color: theme.palette.secondary.main }}
                                >
                                    {selectedPlacementNotAvailable ? <CloseIcon {...defns.closeIcon} /> : <CheckIcon {...defns.checkIcon} />}Placement #{placement} is{' '}
                                    {selectedPlacementNotAvailable ? 'not available' : 'available'}
                                </AfitdTypography>
                            )}

                            {allSlotsAvailable || (selectedPlacementNumber !== selectedPlacementNotAvailable?.pos && queryData?.length > 0) ? (
                                <AfitdTypography {...defns.listText} style={{ color: theme.palette.secondary.main }}>
                                    {<CheckIcon {...defns.checkIcon} />}Placement #{placement} is available
                                </AfitdTypography>
                            ) : (
                                queryData?.length > 0 &&
                                newA.map(el => {
                                    const notAvailblePlacement = queryData?.find(d => d.pos === el);
                                    return (
                                        selectedPlacementNumber !== notAvailblePlacement?.pos && (
                                            <AfitdTypography
                                                {...defns.listText}
                                                style={notAvailblePlacement ? { color: theme.palette.error.main } : { color: theme.palette.secondary.main }}
                                            >
                                                {notAvailblePlacement ? <CloseIcon {...defns.closeIcon} /> : <CheckIcon {...defns.checkIcon} />} Placement #{el} is{' '}
                                                {notAvailblePlacement ? 'not available' : 'available'}
                                            </AfitdTypography>
                                        )
                                    );
                                })
                            )}
                        </div>
                    )}

                    <div style={{ marginLeft: 'auto' }}>
                        <AfitdButton
                            color="primary"
                            disabled={!checkAvailabilityBtnDisabled || loading}
                            onClick={() => handleClickAvailability({ placement, startDt: time, type })}
                        >
                            {loading ? (
                                <>
                                    <CircularProgress size={25} />
                                    &nbsp; Checking...
                                </>
                            ) : (
                                'Check Availability'
                            )}
                        </AfitdButton>
                    </div>
                </div>
            </div>
        );
    };

    const PlacementGrid = props => {
        const { data } = props;
        const queryData = _get(data, 'queryData', []);
        const allSlotsAvailable = _get(data, 'allSlotsAvailable', false);
        const arr = [...Array(4)].map((_, i) => i + 1);
        return (
            <div {...defns.placementAdSection}>
                <Grid {...defns.placementGridContainer}>
                    {arr?.map(el => {
                        const notAvailblePlacement = queryData?.find(d => d.pos === el);
                        return (
                            <Grid {...defns.placementBlock}>
                                <AfitdTypography
                                    {...defns.placementNumber}
                                    style={getPlacementNumberStyle({ queryData, available: Boolean(!notAvailblePlacement), allSlotsAvailable })}
                                >
                                    {el}
                                </AfitdTypography>
                                <AfitdTypography
                                    {...defns.placementAvailabilityText}
                                    style={getPlacementTextStyle({ queryData, available: Boolean(!notAvailblePlacement), allSlotsAvailable })}
                                >
                                    {getPlacementText({ queryData, available: Boolean(!notAvailblePlacement), allSlotsAvailable })}
                                </AfitdTypography>
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
        );
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        checkState,
        setCheckState,
        history,
        isDisabledButton,
        handleNext,
        advertisementData,
        setAdvertisementData,
        unavailablePlacementDialogOpen,
        setUnavailablePlacementDialogOpen,
        loading,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <Container>
                <div {...defns.heading}>Select Page(s)</div>
                <div>
                    <div {...defns.container1}>
                        <Grid {...defns.gridBody}>
                            <Grid {...defns.itemGrid}>
                                <div>
                                    <Checkbox {...defns.jobCenterCheck} />
                                    <span {...defns.title}>
                                        <b>Job Center</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                    </span>
                                </div>
                                <div {...defns.contentBody}>
                                    <p {...defns.features}>Advertising Specifics:</p>
                                    <ul {...defns.listBody}>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span variant="body2" {...defns.qualities}>
                                                    Ad space will be available in quadrants.
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria is
                                                    entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once a
                                                    record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until the
                                                    page is refreshed / reloaded during the paid for time-frame.
                                                </span>
                                            </div>
                                        </li>
                                        <br />
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Grid>
                            <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                <img alt="" {...defns.optionImage} />
                                <PlacementGrid data={jobCenterPlacementData} />
                            </Grid>
                        </Grid>
                    </div>
                    <Collapse in={checkState?.jobCtr}>
                        <CheckAvailabilityComponent
                            placement={jobCenterAdDetails?.placement}
                            time={jobCenterAdDetails?.time}
                            date={jobCenterAdDetails?.date}
                            type="JC"
                            data={jobCenterPlacementData}
                            hideList={hideJobCenterList}
                            loading={jobCtrLoading}
                        />
                    </Collapse>
                </div>
                <div>
                    <div {...defns.container2}>
                        <Grid {...defns.gridBody}>
                            <Grid {...defns.itemGrid}>
                                <div>
                                    <Checkbox {...defns.talentCenterCheck} />
                                    <span {...defns.title}>
                                        <b>Talent Center</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                    </span>
                                </div>
                                <div {...defns.contentBody}>
                                    <p {...defns.features}>Advertising Specifics:</p>
                                    <ul {...defns.listBody}>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span variant="body2" {...defns.qualities}>
                                                    Ad space will be available in quadrants.
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria is
                                                    entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once a
                                                    record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until the
                                                    page is refreshed / reloaded during the paid for time-frame.
                                                </span>
                                            </div>
                                        </li>
                                        <br />
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Grid>
                            <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                <img alt="" {...defns.optionImage2} />
                                <PlacementGrid data={talentCenterPlacementData} />
                            </Grid>
                        </Grid>
                    </div>{' '}
                    <Collapse in={checkState?.talentCtr}>
                        <CheckAvailabilityComponent
                            placement={talentCenterAdDetails?.placement}
                            time={talentCenterAdDetails?.time}
                            date={talentCenterAdDetails?.date}
                            type="TC"
                            data={talentCenterPlacementData}
                            hideList={hideTalentCenterList}
                            loading={talentCtrLoading}
                        />
                    </Collapse>
                </div>
                <div>
                    <div {...defns.container3}>
                        <Grid {...defns.gridBody}>
                            <Grid {...defns.itemGrid}>
                                <div>
                                    <Checkbox {...defns.employerCenterCheck} />
                                    <span {...defns.title}>
                                        <b>Employer Search</b> (${PRICE_ADVERTISEMENT_PLACEMENT} - 30 minutes)
                                    </span>
                                </div>
                                <div {...defns.contentBody}>
                                    <p {...defns.features}>Advertising Specifics:</p>
                                    <ul {...defns.listBody}>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span variant="body2" {...defns.qualities}>
                                                    Ad space will be available in quadrants.
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>Your Ad will likely share display space with other advertisers..</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Your Ad will display on page load for 30 minutes to all users of this page for the date/time selected. Once search criteria is
                                                    entered and a search is executed, the results will display on the left side of the page. Your Ad will still display. Once a
                                                    record is selected/clicked upon, then the details will display on the right side and all Ads will no longer display until the
                                                    page is refreshed / reloaded during the paid for time-frame.
                                                </span>
                                            </div>
                                        </li>
                                        <br />
                                        <li>
                                            <div {...defns.featureBody}>
                                                <span {...defns.qualities}>
                                                    Ads will not display in our Native App. Only in the web app in larger viewports due to lack of space.
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Grid>
                            <Grid {...defns.itemGrid} {...defns.adPlacementPicture}>
                                <img alt="" {...defns.optionImage3} />
                                <PlacementGrid data={empSearchPlacementData} />
                            </Grid>
                        </Grid>
                    </div>
                    <Collapse in={checkState?.empSearch}>
                        <CheckAvailabilityComponent
                            placement={employerSearchAdDetails?.placement}
                            time={employerSearchAdDetails?.time}
                            date={employerSearchAdDetails?.date}
                            type="ES"
                            data={empSearchPlacementData}
                            hideList={hideEmpSearchList}
                            loading={empSearchLoading}
                        />
                    </Collapse>
                </div>

                <br />
                <Grid {...defns.gridBody1}>
                    <Grid {...defns.footerGridItem}>
                        <div {...defns.backButtonContainer}>
                            <AfitdButton {...defns.backButton}>
                                <ArrowBack fontSize="small" />
                                &nbsp; Back {` `}
                            </AfitdButton>
                        </div>
                    </Grid>
                    {smMatches ? null : (
                        <Grid {...defns.progressGrid}>
                            <p>
                                <b>3 of 5</b>
                            </p>
                            <BorderLinearProgress {...defns.progress} />
                        </Grid>
                    )}

                    <Grid {...defns.footerGridItem}>
                        <div {...defns.nextButtonContainer}>
                            <AfitdButton {...defns.nextButton}>
                                {loading ? <CircularProgress size={25} /> : 'Next'}
                                {!loading && (
                                    <>
                                        &nbsp;
                                        <ArrowRightAltIcon fontSize="small" />
                                    </>
                                )}
                            </AfitdButton>
                        </div>
                    </Grid>
                    {smMatches && (
                        <div {...defns.progressGridContainerSm}>
                            <Grid {...defns.progressGrid}>
                                <p>
                                    <b>3 of 5</b>
                                </p>
                                <BorderLinearProgress {...defns.progress} />
                            </Grid>
                        </div>
                    )}
                </Grid>
            </Container>
            <AfitdMessageDialog {...defns.unavailablePlacementDialog} />
        </div>
    );
};

export default Step3Page;
